import { Dispatch, memo, SetStateAction } from 'react';

import { AirportConfiguration, AirportConfigurationType, ResourceType } from '../../../backend';
import { StyledMenuBox } from './LeftMenu.style';
import { LeftMenuItem } from './LeftMenuItem';

export const LeftMenu = memo(function LeftMenu({
    valueType,
    setValueType,
    arrayPush,
    dirty,
    defaultValue,
}: {
    valueType: ResourceType | AirportConfigurationType;
    setValueType: Dispatch<SetStateAction<ResourceType | AirportConfigurationType>>;
    arrayPush: (obj: any) => void;
    dirty: boolean;
    defaultValue?: AirportConfiguration;
}) {
    const valueTypes = ResourceType[valueType as ResourceType] ? ResourceType : AirportConfigurationType;

    return (
        <StyledMenuBox>
            {Object.values(valueTypes).map((type, index) => (
                <LeftMenuItem
                    key={index}
                    type={type}
                    selected={valueType === type}
                    valueType={valueType}
                    setValueType={setValueType}
                    arrayPush={arrayPush}
                    dirty={dirty}
                    defaultValue={defaultValue}
                />
            ))}
        </StyledMenuBox>
    );
});
